import React from "react";
import { useNavigate } from "react-router-dom";

import { IModule } from "../../types";
import { IconBack, IconChevron } from "../../icons";

interface BreadcrumbProps {
  selectedModule: IModule | null;
  segments: { label: string; path: string; navigable?: boolean }[];
}

export function Breadcrumb({ selectedModule, segments }: BreadcrumbProps) {
  const navigate = useNavigate();

  // segments is already filtered by the parent (header.tsx), use directly
  const validSegments = segments;

  return (
    <>
      {selectedModule && (
        <button className="back-btn" type="button" aria-label="Go back" onClick={() => window.history.back()}>
          <IconBack />
        </button>
      )}

      <nav className="crumb-path">
        {selectedModule && (
          <button className="mod-chip" type="button" onClick={() => navigate(selectedModule.link)}>
            <span className="mp-icon">
              <img src={selectedModule.icon} alt="" width={12} height={12} className="mp-icon-img" />
            </span>
            <span className="mp-name">{selectedModule.label}</span>
          </button>
        )}
        {selectedModule && validSegments.map((seg, i) => (
          <React.Fragment key={i}>
            {(i > 0 || selectedModule) && <IconChevron />}
            {i === validSegments.length - 1 ? (
              <span className="cp-current">{seg.label}</span>
            ) : seg.navigable === false ? (
              <span className="cp-text">{seg.label}</span>
            ) : (
              <button className="cp-link" type="button" onClick={() => navigate(seg.path)}>
                {seg.label}
              </button>
            )}
          </React.Fragment>
        ))}
      </nav>
    </>
  );
}

export default Breadcrumb;
